import { useCurrentUser } from '../auth/auth-provider';
import { ManagerQueuePage } from './manager/manager-queue-page';
import { AssignQueuePage } from './accountant/assign-page';
import { DashboardPage } from './dashboard/dashboard-page';

/**
 * "/" resolves to each role's queue, not to a shared landing page.
 *
 * The home screen answers one question — what is waiting for me — and that
 * question has a different answer for each of the three roles.
 */
export function HomeRoute() {
  const user = useCurrentUser();

  switch (user.role) {
    case 'SITE_MANAGER':
      return <ManagerQueuePage />;
    case 'ACCOUNTANT':
      return <AssignQueuePage />;
    case 'ADMIN':
      return <DashboardPage />;
  }
}
